<div>
  <mat-form-field appearance="outline">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input type="text" matInput [formControl]="control()" (keydown)="onKeyDown($event)" />

    @if (control().value && isClear()) {
      <button matSuffix type="button" mat-icon-button aria-label="Clear" (click)="clear()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  @if (validations) {
    <div>
      @if (control().hasError(formValidationsDictionary.Required) && control().touched) {
        <mat-error>{{ validations[formValidationsDictionary.Required]?.message }}</mat-error>
      }
      @if (control().hasError(formValidationsDictionary.MinLength) && !control().hasError(formValidationsDictionary.Required)) {
        <mat-error>{{ validations[formValidationsDictionary.MinLength]?.message }}</mat-error>
      }
      @if (!control().hasError(formValidationsDictionary.Required) && control().hasError(formValidationsDictionary.OnlyNumbers)) {
        <mat-error>{{ validations[formValidationsDictionary.OnlyNumbers]?.message }}</mat-error>
      }
      @if (control().hasError(formValidationsDictionary.MaxLength) && !control().hasError(formValidationsDictionary.Required)) {
        <mat-error>{{ validations[formValidationsDictionary.MaxLength]?.message }}</mat-error>
      }
      @if (control().hasError(formValidationsDictionary.RequiredLength)) {
        <mat-error>{{ validations[formValidationsDictionary.RequiredLength]?.message }}</mat-error>
      }
    </div>
  }
</div>
